import { alpha } from '@mui/material/styles';

import {
  Box,
  FormControlLabel,
  Radio,
  type FormControlLabelProps,
} from '@/primitives';

export interface FramedRadioProps extends Omit<
  FormControlLabelProps,
  'control'
> {}

export function FramedRadio(props: FramedRadioProps) {
  return (
    <Box
      sx={{
        flexGrow: 1,
        flexBasis: 0,
        display: 'flex',
        alignItems: 'center',
        padding: '16px',
        borderRadius: '8px',
        bgcolor: 'background.paper',
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: 'grey.500',
        ':has(.Mui-checked)': {
          bgcolor: (t: any) =>
            t.vars
              ? `rgba(${t.vars.palette.primary.mainChannel} / 0.08)`
              : alpha(t.palette.primary.main, 0.08),
          borderColor: 'primary.main',
        },
        ':has(.Mui-disabled)': {
          borderColor: (t: any) =>
            t.vars
              ? `rgba(${t.vars.palette.text.primaryChannel} / 0.38)`
              : alpha(t.palette.text.primary, 0.38),
        },
      }}
    >
      <FormControlLabel control={<Radio />} {...props} />
    </Box>
  );
}
